/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MyprofilePhoneUtilsModule } from '@myprofile-ui/myprofile-phone-utils'
import {
  PidxInlineFormMessagesModule,
  PidxLoaderModule,
  PidxSkeletonLoaderModule,
  PidxTimerLabelModule,
} from '@myprofile-ui/pidx-ui-components'
import { PidxUtilsModule } from '@myprofile-ui/pidx-utils'
import { TranslatePipe } from '@ngx-translate/core'
import { NgxsModule } from '@ngxs/store'
import { MyProfilePhoneEditFormComponent } from './components/myprofile-phone-editform/myprofile-phone-editform.component'
import { MyProfilePhoneListComponent } from './components/myprofile-phone-list/myprofile-phone-list.component'
import { MyProfilePhoneVerificationComponent } from './components/myprofile-phone-verification/myprofile-phone-verification.component'
import { MyProfileProfilePhoneWidgetComponent } from './myprofile-profile-phone-widget.component'
import { PhoneWidgetState } from './store/phone-widget.state'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  declarations: [
    MyProfileProfilePhoneWidgetComponent,
    MyProfilePhoneListComponent,
    MyProfilePhoneEditFormComponent,
    MyProfilePhoneVerificationComponent,
  ],
  exports: [MyProfileProfilePhoneWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PidxLoaderModule,
    PidxSkeletonLoaderModule,
    PidxUtilsModule,
    PidxTimerLabelModule,
    PidxInlineFormMessagesModule,
    MyprofilePhoneUtilsModule,
    NgxsModule.forFeature([PhoneWidgetState]),
    TranslatePipe,
    PorscheDesignSystemModule,
  ],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class MyProfileProfilePhoneWidgetModule {
  static forRoot(basePath: string, restrictGlobalUIChanges: boolean): ModuleWithProviders<MyProfileProfilePhoneWidgetModule> {
    return {
      ngModule: MyProfileProfilePhoneWidgetModule,
      providers: [{ provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges }],
    }
  }
}
